export { default } from "./FitInput";
